import { render, staticRenderFns } from "./EditStep.vue?vue&type=template&id=0065f60d&scoped=true"
import script from "./EditStep.vue?vue&type=script&lang=js"
export * from "./EditStep.vue?vue&type=script&lang=js"
import style0 from "./EditStep.vue?vue&type=style&index=0&id=0065f60d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065f60d",
  null
  
)

export default component.exports